import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';
import {SvgPathService} from "./svg-path.service";

@Directive({
  selector: 'app-svg'
})
export class SvgPathDirective implements AfterViewInit {

  @Input() name: string;

  constructor(private svgService: SvgPathService , private el: ElementRef) {
  }

  ngAfterViewInit(): void {
    this.el.nativeElement.insertAdjacentHTML('beforeend' , this.svgService.getSvgName(this.name));
  }

}
